// Physical device haptics via the Vibration API (Android/Chrome; graceful no-op elsewhere).
let _timer = null;
let _active = false;

function supported() {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

function safeVibrate(arg) {
  try {
    navigator.vibrate(arg);
  } catch (e) {
    /* blocked before user gesture / unsupported — ignore */
  }
}

// Build a ~1s vibration pattern scaled by magnitude and mode.
function pattern(magnitude, mode) {
  // exponential intensity 0..1
  const k = Math.pow(THREEclamp((magnitude - 3) / 6.5), 2.2);
  if (mode === "street") {
    // sharp, erratic structural shake
    const arr = [];
    const bursts = 6 + Math.round(k * 8);
    for (let i = 0; i < bursts; i++) {
      arr.push(20 + Math.round(Math.random() * (40 + k * 90))); // on
      arr.push(15 + Math.round(Math.random() * 50)); // off
    }
    return arr;
  }
  // aerial: deep steady thrum
  const on = 120 + Math.round(k * 520);
  const off = 60 - Math.round(k * 40);
  return [on, Math.max(20, off), on, Math.max(20, off)];
}

function THREEclamp(v) {
  return Math.max(0, Math.min(1, v));
}

export function startHaptics(magnitude, mode) {
  if (!supported()) return;
  stopHaptics();
  _active = true;
  const fire = () => safeVibrate(pattern(magnitude, mode));
  fire();
  _timer = setInterval(fire, 1000);
}

export function stopHaptics() {
  if (!supported()) return;
  if (_timer) {
    clearInterval(_timer);
    _timer = null;
  }
  if (_active) {
    safeVibrate(0);
    _active = false;
  }
}
